export default __webpack_public_path__ + "static/media/CustomManualLaunchGuideLogo.f35dcca8.png";